export default __webpack_public_path__ + "static/media/guest_02_2_marco_ornellas_trampapo.fb49b937.png";